import { Flex } from '@/components/Flex';
import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import type { MoneyFragment } from '@/graphql/saleor/api';
import type { Maybe } from '@/lib/types';
import { useConfigProvider } from '@/providers/ConfigProvider';

const ZipWidget = ({
  countryCode,
  price,
  variantCTA,
}: {
  countryCode: string;
  price: Maybe<MoneyFragment>;
  variantCTA?: OrderAppCtaType;
}) => {
  const merchantPublicKey =
    process.env.NEXT_PUBLIC_ZIP_MERCHANT_PUBLIC_KEY ?? '';

  const env = process.env.NEXT_PUBLIC_ZIP_ENV as 'sandbox' | 'production';

  const { zipPaymentMax, zipPaymentMin } = useConfigProvider();

  if (
    !price ||
    variantCTA !== 'ORDER' ||
    price.amount > (zipPaymentMax ?? 0) ||
    price.amount < (zipPaymentMin ?? 0)
  )
    return null;

  return (
    <Flex style={{ transition: 'height .2s ease-in-out' }}>
      <div
        data-env={env}
        data-testid='zipBanner'
        data-zm-asset='stripbanner'
        data-zm-merchant={merchantPublicKey}
        data-zm-region={countryCode.toLowerCase()}
        data-zm-widget='inline'
      />
    </Flex>
  );
};

export default ZipWidget;
